import type { Moment } from 'moment'
import { RRule } from 'rrule'

import Policy from 'modules/payroll_bundle/store/models/Policy'

export default function enableDay({
  day,
  recurrence,
}: {
  day: Moment
  recurrence: string
}): boolean {
  if (recurrence === Policy.periodicities().every_2_weeks.recurrence) return true

  const options = RRule.parseString(recurrence)
  options.dtstart = new Date(Date.UTC(2000, 1, 1))

  const rule = new RRule(options)
  const dayInUTC = new Date(Date.UTC(day.year(), day.month(), day.date()))

  return rule.between(dayInUTC, dayInUTC, true).length > 0
}
